import dayjs from 'dayjs';
import {setMetadata} from '../../../core/data-source/data-source';
import {HttpCrudDataSource, RestResponseRecord} from '../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';

export class DailyRunsReportCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/reports/dailyRunsReport';

    async load(): Promise<T[]> {
        return httpService
            .get(this.apiPath, {transformResponse: (data: any) => new Function(' return ' + data)()})
            .then((response) =>
                setMetadata(
                    response.data.reportRecords[0].dailyRunsSelectorRecords.map((v: any) =>
                        fromJson(this.recordClass, v)
                    ),
                    fromJson(RestResponseRecord, response.data)
                )
            );
    }

    exportReport(fileName: string): Window {
        const url: string =
            httpService.getBaseUrl() +
            '/gt/gt-api/reports/dailyRunsReport/' +
            dayjs.utc().startOf('day').valueOf() +
            '/?type=Excel&fileName=' +
            fileName;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
